<template>
  <section class="account-component-readonly">
    <div class="account-component-readonly-profil-edit">
      <IconLabel heavy no-padding :label="$t('ETAB.PAGES.PROFIL.@ACCOUNT_INFORMATION')" icon="icon-f-settings" :icon-right="false" />
      <QBtn icon="edit" color="secondary" round @click.prevent="$emit('passAccountToWriteMode')" />
    </div>
    <div>
      <label>{{ $t("ETAB.FORMS.LABELS.@LASTNAME") }}</label>
      <p>{{ account[IAccount.lastname] }}</p>
    </div>

    <div>
      <label>{{ $t("ETAB.FORMS.LABELS.@FIRSTNAME") }}</label>
      <p>{{ account[IAccount.firstname] }}</p>
    </div>

    <div>
      <label>{{ $t("ETAB.FORMS.LABELS.@MOBILE_NUMBER") }}</label>
      <p>{{ account[IAccount.phone] }}</p>
    </div>

    <div>
      <label>{{ $t("ETAB.FORMS.LABELS.@EMAIL") }}</label>
      <p>{{ account[IAccount.email] }}</p>
    </div>
  </section>
</template>

<script>
  import { AccountModel, IAccount } from "@core/models";

  export default {
    props: {
      account: { type: Object, default: () => new AccountModel() },
    },
    emits: ["passAccountToWriteMode"],
    created() {
      this.IAccount = IAccount;
    },
  };
</script>

<style lang="scss">
  .account-component-readonly {
    .account-component-readonly-profil-edit {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    label {
      display: block;
      margin-top: 15px;
      font-weight: bold;
    }
  }
</style>
